import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import {
  RootState,
  selectExternalTransactions,
  selectTransactions,
} from '@helios/state-management'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { ToastService } from '@northfork/ng-basics'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators'
import { TransactionDetailKey } from '../panel-key'
import { TransactionDetailService } from './services/transaction-detail.service'

interface TransactionDetailState {
  prop: string
}

@Component({
  selector: 'hs-transaction-detail',
  templateUrl: './transaction-detail-panel.component.html',
  styleUrls: ['./transaction-detail-panel.component.scss'],
})
export class TransactionDetailPanelComponent
  extends BasePanelComponent<TransactionDetailState>
  implements AfterViewInit, OnDestroy
{
  panelKey = TransactionDetailKey
  private readonly destroySubject = new Subject<void>()
  externalTransactionId: number | undefined
  clearwaterTransactionId: string | undefined
  loadingData = false
  isMultiMatch = false

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    readonly store: Store<RootState>,
    public transactionDetailService: TransactionDetailService,
    private readonly modalService: NgbModal,
    public toastService: ToastService,
  ) {
    super(container)
  }
  ngOnDestroy(): void {
    this.destroySubject.next()
    this.destroySubject.complete()
  }

  ngAfterViewInit(): void {
    this.store
      .select(selectExternalTransactions)
      .pipe(
        takeUntil(this.destroySubject),
        distinctUntilChanged(),
        tap(externalTransactions => {
          const externalTranId = externalTransactions[0]?.extTranId
          if (externalTranId) {
            this.setExternalTransactionSelected(externalTranId)
          } else {
            this.setExternalTransactionSelected(undefined)
            this.setCWTransactionSelected(undefined)
          }
        }),
      )
      .subscribe()

    this.store
      .select(selectTransactions)
      .pipe(
        takeUntil(this.destroySubject),
        distinctUntilChanged(),
        tap(trans => {
          if (trans && trans.length > 0) {
            this.isMultiMatch = false
            if (
              Number(trans[0].custodyMatches) > 1 ||
              Number(trans[0].tradingMatches) > 1
            ) {
              this.isMultiMatch = true
            }
            this.setCWTransactionSelected(trans[0].tranId)
          } else {
            this.setExternalTransactionSelected(undefined)
            this.setCWTransactionSelected(undefined)
          }
        }),
      )
      .subscribe()
  }

  setExternalTransactionSelected(externalTransId: number | undefined) {
    this.externalTransactionId = externalTransId
  }

  setCWTransactionSelected(cwTransactionId: string | undefined) {
    this.clearwaterTransactionId = cwTransactionId
  }

  setloadingData(loadingData: boolean) {
    this.loadingData = loadingData
  }
}
